import { api_GET, api_POST, api_PUT, api_DELETE } from "./_api.js";

const solicitacaoVistoria_api = {
    GetList: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`SolicitacaoVistoria/GetList`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`SolicitacaoVistoria/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetFuncionalidadeFiscal: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`SolicitacaoVistoria/GetFuncionalidadeFiscal`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("SolicitacaoVistoria", obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("SolicitacaoVistoria", obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    UpdateSolicitacaoVistoriaArquivar: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("SolicitacaoVistoria/UpdateSolicitacaoVistoriaArquivar", obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListGeradorVistorias: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`SolicitacaoVistoria/GetListGeradorVistorias`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListTransportadorVistorias: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`SolicitacaoVistoria/GetListTransportadorVistorias`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}
export default solicitacaoVistoria_api;